import * as React from 'react';
import { Upload, message } from "antd";
import styled from 'styled-components';
import { COURSE_H5P_UPLOAD_PATH } from '../../constant/comman';

const Dragger = Upload.Dragger;

const StyledDragger = styled(Dragger)`
  & .ant-upload {
    margin-bottom: 15px;
  }

  & .ant-upload-drag {
    margin-bottom: 15px;
  }
  & .ant-upload-list-item-actions {
    display: none;
  }
`;

const props = {
  name: 'file',
  action: COURSE_H5P_UPLOAD_PATH,
  headers: {
    authorization: 'authorization-text'
  },
  accept: ".h5p,.zip,.html"
};

var temp = [];
var isUploadClick = false;

export class AddH5p extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disable: true,
      jsonFile: [],
      disableUpload: true
    };
    this.handleChange = this.handleChange.bind(this);
    this.verifyDoc = this.verifyDoc.bind(this);
  }

  componentDidMount() {
    if (this.props.refx) {
      this.props.refx(this);
    }
  }

  verifyDoc() {
    isUploadClick = true;

    if (temp.length <= 0) {
      return;
    }

    const bannerData = {
      media_name: temp[0].response.file,
      type: 'image',
      media_type: 'banner'
    };

    if (typeof this.props.onUpload === 'function') {
      this.props.onUpload(temp[0].response.file, bannerData);
    }
  }

  handleChange(info) {
    const maxSize = 30 * 1024 * 1024; // 30MB
    if (info.file.size > maxSize) {
      message.error("File size must be less than 30MB!");
      return;
    }
    if (info.file.status !== 'uploading') {
      if (info.fileList.length < 1) {
        this.setState({
          disable: true
        });
      } else {
        this.setState({
          disable: false
        });
      }
    }

    if (info.file.status === 'done') {
      if (info.file.response && info.file.response.code === 'ERROR_IN_UPLOAD') {
        message.error(info.file.response.msg);
      } else if (info.file.response && info.file.response.file) {
        message.success(`${info.file.name} file uploaded successfully.`);
        temp = info.fileList;
        this.verifyDoc();
      }
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  }

  handleCancel = (e) => {
    this.hide();
  };

  show() {
    this.setState({
      visible: true
    });
  }

  hide() {
    this.setState(
      {
        visible: false
      },
      () => (isUploadClick ? this.props.onUpload(temp) : this.props.onUpload(null))
    );
  }

  render() {
    return (
      <div className="premium-upload-container">
        <StyledDragger
          className="premium-upload-dragger"
          {...props}
          accept={this.props.accept || ".h5p,.zip,.html"}
          onChange={this.handleChange}
          onRemove={(file) => console.log('Removed -- ', file)}
        >
          <div className="premium-upload-icon-wrapper">
            <svg viewBox="0 0 24 24">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" />
            </svg>
          </div>
          <p className="premium-upload-text">
            {this.props.title || "Click or drag file to this area"}
          </p>
          <p className="premium-upload-hint">
            {this.props.hint || "Supports single file upload (Max 30MB)"}
          </p>
        </StyledDragger>
      </div>
    );
  }
}
